import { css } from '@emotion/react';
import { NewsCard } from '@/components/general/NewsCard';
import { SectionTitle } from '@/components/general/SectionTitle';
import { ButtonLink } from '@/components/shared/ButtonLink';
import { useNewsQuery } from '@/hooks/useNewsQuery';
import { pagesPath } from '@/lib/pagesPath';
import { getScreen } from '@/styles/media-query';
import { withPrefix } from 'gatsby';

export type NewsSectionProps = {
  className?: string;
};

export const NewsSection: React.FC<NewsSectionProps> = ({ className }) => {
  const { items } = useNewsQuery();

  return (
    <section
      id="news"
      css={css`
      
        text-align: center;
        margin: 70px 0 112px;
        padding: 0 20px;

        @media ${getScreen('pc', '未満')} {
          margin: 64px 0 80px;
          padding: 0 20px;
        }
      `}
      className={className}
    >
      <div
        css={css`
          margin: auto;
          margin-bottom: 45px;
          @media ${getScreen('pc')} {
            margin-bottom: 90px;
          }
        `}
      >
        <a
          href="https://www.youtube.com/watch?v=JUMldrx68JY"
          target="_blank"
          rel="noreferrer"
        >
          <img
            css={css`
              max-width: 100%;
              height: auto;
              display: none;
              @media ${getScreen('pc')} {
                display: inline-block;
              }
            `}
            src={withPrefix('/images/movie/bnr_movie-pc.png')}
            width="1011"
            height="206"
            alt="Uniforce公式チャンネル「ユニチューブ」で準備期間の課題への向き合い方や解決策を随時配信中！"
          />
          <img
            css={css`
              max-width: 100%;
              width: 100%;
              height: auto;
              @media ${getScreen('pc')} {
                display: none;
              }
            `}
            src={withPrefix('/images/movie/bnr_movie-sp.png')}
            width="338"
            height="180"
            alt="Uniforce公式チャンネル「ユニチューブ」で準備期間の課題への向き合い方や解決策を随時配信中！"
          />
        </a>
      </div>
      <SectionTitle en="INFORMATION" as="h2">
        <strong>お知らせ</strong>
      </SectionTitle>
      <ul
        css={css`
          display: flex;
          flex-direction: column;
          max-width: 1000px;
          gap: 40px;
          justify-content: center;
          margin: 48px auto 0;

          @media ${getScreen('pc')} {
            margin: 80px auto 0;
            display: grid;
            grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
          }
        `}
      >
        {items.map((item) => (
          <li key={item.ipoNewsId}>
            <NewsCard
              css={css`
                height: 100%;
              `}
              item={item}
            />
          </li>
        ))}
      </ul>
      <ButtonLink
        css={css`
          margin: 64px 20px 0;

          @media ${getScreen('pc')} {
            width: 221px;
            margin: 80px auto 0;
          }
        `}
        to={pagesPath.news.$url()}
        variant="top-more"
      >
        一覧を見る
      </ButtonLink>
    </section>
  );
};
